import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@cibli/shared';
import { useTranslation } from 'react-i18next';
type EndModalProps = {
  onConfirm: () => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const EndModal = ({ onConfirm, open, onOpenChange }: EndModalProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="min-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-2xl font-bold">{t('EndModal.title')}</AlertDialogTitle>
          <AlertDialogDescription className="text-lg">
            {t('EndModal.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" size="lg" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>
          <Button
            size="lg"
            onClick={() => {
              onOpenChange(false);
              void onConfirm();
            }}
          >
            {t('common.confirm')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default EndModal;
